import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {ITagsWebServiceClient} from "@common/resources/resources";

@Injectable()
export class TagsResolver implements Resolve<Boolean> {

  constructor(private iTagsWebServiceClient: ITagsWebServiceClient) {
  }

  resolve() {
    return this.iTagsWebServiceClient.isFormulaireDematEnabled();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/tags.resolver.ts